import API from "../../../../config/api";
import getUserInfo from "@/assets/js/user/getUserInfo";
export default {
    data() {
        return {
            walletGroup: {

            },
            active_tab: 'promoteRecord',
            money: {
                withDrawlMoney: 0,
                cashMoney: 0,
                leftMoney: 0,
            },
            promoteRecordTable: {
                data: [],
                total: 0,
                pageNum: 1,
                pageSize: 10,
                loading: false,
                url: API.getUserPromoteList,
            },
            withDrawlRecordTable: {
                data: [],
                total: 0,
                pageNum: 1,
                pageSize: 10,
                loading: false,
                url: API.getUserWithdrawlList,
            },
            withDrawlShow: false, //提现的模态窗
            withDrawlMoneyNow: 0, //输入的提现金额
        }
    },
    methods: {
        getPromoteMoneyByUserId() {
            let header = {
                "Content-Type": "application/x-www-form-urlencoded"
            }
            let data = {}
            this.$axiosRequest({
                url: API.getPromoteMoneyByUserId,
                method: 'POST',
                data: data,
                header: header,
                success: res => {
                    this.money.promoteMoney = res.data.promoteMoney;
                    this.money.withDrawlMoney = res.data.withDrawlMoney;
                    this.money.leftMoney = res.data.leftMoney;
                }
            });

        },
        async getData(which) {
            let table
            if (which == 'promote') {
                table = this.promoteRecordTable
            } else {
                table = this.withDrawlRecordTable
            }
            table.loading = true

            let header = {
                "Content-Type": "application/x-www-form-urlencoded"
            }
            let data = {
                pageSize: table.pageSize,
                pageNum: table.pageNum,
            }
            this.$axiosRequest({
                url: table.url,
                method: 'POST',
                data: data,
                header: header,
                success: res => {
                    if (which == 'promote') {
                        table.data = res.data["userPromoteList"]
                        table.total = res.data.total
                        table.loading = false
                    } else {
                        table.data = res.data["userWithdrawlList"]
                        table.total = res.data.total
                        table.loading = false
                    }
                }
            });

        },
        userWithdrawlApply() {
            let self=this;
            console.log('comfirm')
            let header = {
                "Content-Type": "application/x-www-form-urlencoded",
            }
            let data = {
                money: this.withDrawlMoneyNow
            }
            this.$axiosRequest({
                url: API.userWithdrawlApply,
                method: 'POST',
                data: data,
                header: header,
                success: res => {
                    console.log(res.data);
                    if (res.data > 0) {
                        self.$message({type: 'success', message: '申请提现成功'});
                        self.withDrawlShow = false;
                        self.withDrawlMoneyNow = 0;
                        self.getData("withDrawl")
                        self.getPromoteMoneyByUserId()
                    } else if (res.data == -3) {
                        self.$message({type: 'warning', message: '提现金额过大'});
                        self.withDrawlShow = false;
                        self.withDrawlMoneyNow = 0;
                    } else if (res.data == -2) {
                        self.$message({type: 'warning', message: '参数出错'});
                        self.withDrawlShow = false;
                        self.withDrawlMoneyNow = 0;
                    } else if (res.data == -1) {
                        self.$message({type: 'warning', message: '系统错误，发布失败'});
                        self.withDrawlShow = false;
                        self.withDrawlMoneyNow = 0;
                    }
                }
            });

        },

    },
    async mounted() {

        await getUserInfo()
        this.getPromoteMoneyByUserId()
        await this.getData("promote")
        await this.getData("withDrawl")
    },
    /* eslint-disable */
    //导航栏返回指定路径
    // onBackPress(e){
    //     this.$router.push("/pages/usercenter/usercenter");
    //     return true;  //这句一定要有
    // },
}
